import { h } from "hyperapp";

import { columnSelector } from "../../common/column-selector/column-selector";
import { keywordFilter } from "../../common/keyword-filter/main";
import { actionsOnSelected } from "../../common/list-item-selector/actions-on-seleted";
import { pagination } from "../../common/pagination/pagination";
import { emptyState } from "../../common/empty-state/empty-state";
import { regionLoading } from "../../common/region-loading/region-loading";
import { controls } from "./controls";
import { list } from "./list";
import { format, subMonths } from "date-fns";
import { mainTooltip } from "../../common/main-tooltip/main-tooltip";

import listCSS from "./list.css";

const INITIAL_PAGE_SIZE = 5;
const BASE_PAGE_SIZE = 25;

export const main = ({
  actions,
  section,
  state,
  translations,
}): JSX.Element => {
  const {
    categories,
    portifolios,
    clientID,
    loadingCategories,
    loadingPortifolios,
    unvisitedPlaces: {
      portifolio,
      category,
      lastFetch: {
        failed,
        lastFailure,
        reason: { message },
      },
      loadingUnvisitedPlaces,
      pagination: {
        currentPageNumber,
        currentPageSize,
        isLoading,
        itemCount,
        pageCount,
        pageNumber,
        pageNumberInvalid,
        pageSize,
      },
      since,
      until,
      isLoaded,
      hasSelectedAPlace,
      selectedPlace,
      radius,
    },
  } = state;

  const firstPageLoad = () => {
    const unvisitedPlaces = {
      ...state.unvisitedPlaces,
    };
    const unvisitedPlacesIsEmpty =
      Array.isArray(unvisitedPlaces.items) && unvisitedPlaces.items.length <= 0;

    if (
      unvisitedPlacesIsEmpty &&
      !unvisitedPlaces.loadingUnvisitedPlaces &&
      !isLoaded
    ) {
      actions.setPagination({
        pageSize: INITIAL_PAGE_SIZE,
        section,
      });
      actions.fetchUnvisitedPlaces();
    }
  };
  return (
    <div>
      <div class="ml-4 mt-2 d-flex flex-column justify-content-center">
        <div class="d-flex">
          <p class="ml-4" style="font-weight:bold; font-size:16px; color:#666;">
            Relatórios /
          </p>

          <p style="font-weight:400; font-size:16px; color:#666;">
            {translations["unvisitedPlaces"]}
          </p>
        </div>
        <div class="ml-4 d-flex align-items-center" style="margin-bottom:1em;">
          <svg style="width:15px; height:20px;">
            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M11.75 9.6875V10.7812C11.75 11.0391 11.5391 11.25 11.2812 11.25H4.71875C4.46094 11.25 4.25 11.0391 4.25 10.7812V9.6875C4.25 9.42969 4.46094 9.21875 4.71875 9.21875H11.2812C11.5391 9.21875 11.75 9.42969 11.75 9.6875ZM11.2812 12.5H4.71875C4.46094 12.5 4.25 12.7109 4.25 12.9688V14.0625C4.25 14.3203 4.46094 14.5312 4.71875 14.5312H11.2812C11.5391 14.5312 11.75 14.3203 11.75 14.0625V12.9688C11.75 12.7109 11.5391 12.5 11.2812 12.5ZM15.5 5.15234V18.125C15.5 19.1602 14.6602 20 13.625 20H2.375C1.33984 20 0.5 19.1602 0.5 18.125V1.875C0.5 0.839844 1.33984 0 2.375 0H10.3477C10.8438 0 11.3203 0.199219 11.6719 0.550781L14.9492 3.82812C15.3008 4.17578 15.5 4.65625 15.5 5.15234ZM10.5 2.02734V5H13.4727L10.5 2.02734ZM13.625 18.125V6.875H9.5625C9.04297 6.875 8.625 6.45703 8.625 5.9375V1.875H2.375V18.125H13.625Z"
              fill="#666666"
            />
          </svg>
          <p
            class="ml-2"
            style="margin-bottom:0;font-weight:700; color:#666; font-size:22px;"
          >
            {translations["unvisitedPlaces"]}
          </p>
        </div>
        <p style="margin-bottom:0">
          <span
            class="ml-4"
            style="font-weight:400; font-size:14px; color:#212529;"
          >
            Veja Locais Não Visitados "Desde" uma data, ou Locais que não foram
            visitados dentro de um período (Desde e Até).{" "}
          </span>
          <a
            style="text-decoration:underline;"
            href="https://help.contele.io/pt-br/knowledge/locais-nao-visitados"
          >
            Saiba mais.
          </a>{" "}
        </p>
      </div>

      <div class="container-fluid d-flex flex-column flex-md-column flex-lg-row flex-xl-row p-3 ">
        {/* filters */}

        <div
          class="d-flex flex-column col-auto col-md-auto col-lg-3 col-xl-2 noPrint"
          style="min-width: 25vw;"
        >
          <div class="card">
            <div class={listCSS["custom-controls-header"]} style="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                class="mr-2"
              >
                <path
                  d="M5.83332 1.1875V4.3125C5.83332 4.83027 5.41359 5.25 4.89582 5.25H0.9375C0.419727 5.25 0 4.83027 0 4.3125V1.1875C0 0.669727 0.419727 0.25 0.9375 0.25H4.89582C5.41359 0.25 5.83332 0.669727 5.83332 1.1875ZM12.9167 10.5625V7.4375C12.9167 6.91973 12.497 6.5 11.9792 6.5H8.02082C7.50305 6.5 7.08332 6.91973 7.08332 7.4375V10.5625C7.08332 11.0803 7.50305 11.5 8.02082 11.5H11.9791C12.497 11.5 12.9167 11.0803 12.9167 10.5625ZM14.1667 1.1875V4.3125C14.1667 4.83027 14.5864 5.25 15.1042 5.25H19.0625C19.5803 5.25 20 4.83027 20 4.3125V1.1875C20 0.669727 19.5803 0.25 19.0625 0.25H15.1042C14.5864 0.25 14.1667 0.669727 14.1667 1.1875ZM12.9167 4.3125V1.1875C12.9167 0.669727 12.497 0.25 11.9792 0.25H8.02082C7.50305 0.25 7.08332 0.669727 7.08332 1.1875V4.3125C7.08332 4.83027 7.50305 5.25 8.02082 5.25H11.9791C12.497 5.25 12.9167 4.83027 12.9167 4.3125ZM4.89582 6.5H0.9375C0.419727 6.5 0 6.91973 0 7.4375V10.5625C0 11.0803 0.419727 11.5 0.9375 11.5H4.89582C5.41359 11.5 5.83332 11.0803 5.83332 10.5625V7.4375C5.83332 6.91973 5.41359 6.5 4.89582 6.5ZM0 13.6875V16.8125C0 17.3303 0.419727 17.75 0.9375 17.75H4.89582C5.41359 17.75 5.83332 17.3303 5.83332 16.8125V13.6875C5.83332 13.1697 5.41359 12.75 4.89582 12.75H0.9375C0.419727 12.75 0 13.1697 0 13.6875ZM15.1042 11.5H19.0625C19.5803 11.5 20 11.0803 20 10.5625V7.4375C20 6.91973 19.5803 6.5 19.0625 6.5H15.1042C14.5864 6.5 14.1667 6.91973 14.1667 7.4375V10.5625C14.1667 11.0803 14.5864 11.5 15.1042 11.5ZM15.1042 17.75H19.0625C19.5803 17.75 20 17.3303 20 16.8125V13.6875C20 13.1697 19.5803 12.75 19.0625 12.75H15.1042C14.5864 12.75 14.1667 13.1697 14.1667 13.6875V16.8125C14.1667 17.3303 14.5864 17.75 15.1042 17.75ZM7.08332 13.6875V16.8125C7.08332 17.3303 7.50305 17.75 8.02082 17.75H11.9791C12.4969 17.75 12.9166 17.3303 12.9166 16.8125V13.6875C12.9166 13.1697 12.4969 12.75 11.9791 12.75H8.02082C7.50305 12.75 7.08332 13.1697 7.08332 13.6875Z"
                  fill="#666666"
                />
              </svg>
              <span class={listCSS["custom-controls-header-text"]}>
                Filtros
              </span>
            </div>
            <div class="card-body">
              {controls({
                translations,
                actions,
                section,
                state: {
                  categories,
                  categoryID: category ? category.id : undefined,
                  clientID,
                  loadingCategories,
                  loadingPortifolios,
                  loadingUnvisitedPlaces,
                  pageNumber,
                  pageSize,
                  portifolioID: portifolio ? portifolio.id : undefined,
                  portifolios,
                  since: since
                    ? since
                    : format(
                        subMonths(new Date(), 1),
                        "YYYY-MM-DD",
                      ) /* DD = dia do mês para versão do date-fns utilizada (1.30.1); */,
                  until: until ? until : format(new Date(), "YYYY-MM-DD"),
                  hasSelectedAPlace,
                  selectedPlace,
                  radius,
                },
                basePageSize: BASE_PAGE_SIZE,
                initialPageSize: INITIAL_PAGE_SIZE,
              })}
            </div>
          </div>
          {failed && (
            <div
              class="alert alert-danger animated pulse"
              key={`fetchUnvisitedPlacesFailed::${lastFailure}`}
              role="alert"
            >
              {message}
            </div>
          )}
          <div class="mb-2 mt-2" />
        </div>
        {/* content */}
        <div
          class="d-flex flex-column col-auto col-md-auto col-lg-9 col-xl-10"
          style="padding: 0 3% 0; width:45vw; max-width:67vw;"
        >
          <div class="row styleToPrint">
            <div className="col-4 mb-2">
              {keywordFilter({
                translations,
                onChanged: ({ keyword }) => {
                  if (keyword === state.unvisitedPlaces.keyword) return;
                  actions.setUnvisitedPlacesKeyword({ keyword });
                  hasSelectedAPlace
                    ? actions.fetchUnvisitedPlacesNearby()
                    : actions.fetchUnvisitedPlaces();
                },
              })}
            </div>
            <div className="col-8">
              <div className="d-flex justify-content-end align-items-center mr-2">
                <div class="mr-2">
                  <a
                    href="https://help.contele.io/pt-br/knowledge/locais-nao-visitados"
                    target="_blank"
                    style="display: flex; align-items: center; color: #1c7ebb;"
                  >
                    <img
                      src="https://images.contelege.com.br/cge-assets/images/help.svg"
                      style="height: 30px"
                    />
                    {translations["help"]}
                  </a>
                </div>
                <div class="ml-3">
                  <a
                    style="display: flex; align-items: center; color: #1c7ebb;"
                    disabled={loadingUnvisitedPlaces}
                    onclick={() => window.print()}
                  >
                    <svg
                      class="mr-2"
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                    >
                      <path
                        d="M14 6V2.41406C14 2.14875 13.8947 1.89469 13.7072 1.70687L12.2928 0.292812C12.1053 0.105312 11.8509 0 11.5856 0H3C2.44781 0 2 0.447812 2 1V6C0.895313 6 0 6.89531 0 8V11.5C0 11.7762 0.22375 12 0.5 12H2V15C2 15.5522 2.44781 16 3 16H13C13.5522 16 14 15.5522 14 15V12H15.5C15.7762 12 16 11.7762 16 11.5V8C16 6.89531 15.1047 6 14 6ZM12 14H4V11H12V14ZM12 7H4V2H10V3.5C10 3.77625 10.2238 4 10.5 4H12V7ZM13.5 9.25C13.0859 9.25 12.75 8.91406 12.75 8.5C12.75 8.08562 13.0859 7.75 13.5 7.75C13.9141 7.75 14.25 8.08562 14.25 8.5C14.25 8.91406 13.9141 9.25 13.5 9.25Z"
                        fill="#9DACB7"
                      />
                    </svg>
                    <span style="color:#666666; font-size:13px; cursor:pointer;">
                      {"Imprimir Página"}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div
            style="height:5.5vh;"
            class={
              "styleToPrint d-flex flex-column flex-md-row align-items-center ml-0 mr-0 noPrint " +
              listCSS["table-custom-header"]
            }
          >
            <div class="d-flex align-items-center col-md-4 col-lg-4 col-sm-12 p-0 mb-3 mb-md-0">
              {/* {keywordFilter({
                translations,
                onChanged: ({ keyword }) => {
                  if (keyword === state.unvisitedPlaces.keyword) return;

                  actions.setUnvisitedPlacesKeyword({ keyword });
                  actions.fetchUnvisitedPlaces();
                },
              })} */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="18"
                viewBox="0 0 20 18"
                fill="none"
                class="mr-2"
              >
                <path
                  d="M5.83332 1.1875V4.3125C5.83332 4.83027 5.41359 5.25 4.89582 5.25H0.9375C0.419727 5.25 0 4.83027 0 4.3125V1.1875C0 0.669727 0.419727 0.25 0.9375 0.25H4.89582C5.41359 0.25 5.83332 0.669727 5.83332 1.1875ZM12.9167 10.5625V7.4375C12.9167 6.91973 12.497 6.5 11.9792 6.5H8.02082C7.50305 6.5 7.08332 6.91973 7.08332 7.4375V10.5625C7.08332 11.0803 7.50305 11.5 8.02082 11.5H11.9791C12.497 11.5 12.9167 11.0803 12.9167 10.5625ZM14.1667 1.1875V4.3125C14.1667 4.83027 14.5864 5.25 15.1042 5.25H19.0625C19.5803 5.25 20 4.83027 20 4.3125V1.1875C20 0.669727 19.5803 0.25 19.0625 0.25H15.1042C14.5864 0.25 14.1667 0.669727 14.1667 1.1875ZM12.9167 4.3125V1.1875C12.9167 0.669727 12.497 0.25 11.9792 0.25H8.02082C7.50305 0.25 7.08332 0.669727 7.08332 1.1875V4.3125C7.08332 4.83027 7.50305 5.25 8.02082 5.25H11.9791C12.497 5.25 12.9167 4.83027 12.9167 4.3125ZM4.89582 6.5H0.9375C0.419727 6.5 0 6.91973 0 7.4375V10.5625C0 11.0803 0.419727 11.5 0.9375 11.5H4.89582C5.41359 11.5 5.83332 11.0803 5.83332 10.5625V7.4375C5.83332 6.91973 5.41359 6.5 4.89582 6.5ZM0 13.6875V16.8125C0 17.3303 0.419727 17.75 0.9375 17.75H4.89582C5.41359 17.75 5.83332 17.3303 5.83332 16.8125V13.6875C5.83332 13.1697 5.41359 12.75 4.89582 12.75H0.9375C0.419727 12.75 0 13.1697 0 13.6875ZM15.1042 11.5H19.0625C19.5803 11.5 20 11.0803 20 10.5625V7.4375C20 6.91973 19.5803 6.5 19.0625 6.5H15.1042C14.5864 6.5 14.1667 6.91973 14.1667 7.4375V10.5625C14.1667 11.0803 14.5864 11.5 15.1042 11.5ZM15.1042 17.75H19.0625C19.5803 17.75 20 17.3303 20 16.8125V13.6875C20 13.1697 19.5803 12.75 19.0625 12.75H15.1042C14.5864 12.75 14.1667 13.1697 14.1667 13.6875V16.8125C14.1667 17.3303 14.5864 17.75 15.1042 17.75ZM7.08332 13.6875V16.8125C7.08332 17.3303 7.50305 17.75 8.02082 17.75H11.9791C12.4969 17.75 12.9166 17.3303 12.9166 16.8125V13.6875C12.9166 13.1697 12.4969 12.75 11.9791 12.75H8.02082C7.50305 12.75 7.08332 13.1697 7.08332 13.6875Z"
                  fill="#666666"
                />
              </svg>
              <span style="margin-bottom:0; line-height:0" class="ml-2 mr-2">
                {" "}
                {translations["unvisitedPlaces"]}
              </span>
              {mainTooltip({
                text: "",
                withIcon: true,
                link:
                  "https://help.contele.io/pt-br/knowledge/locais-nao-visitados",
                texts: [
                  translations["explainNearPlacesTooltipText1"],
                  translations["explainNearPlacesTooltipText2"],
                  translations["explainNearPlacesTooltipText3"],
                  translations["explainNearPlacesTooltipText4"],
                  translations["explainNearPlacesTooltipText5"],
                ],
              })}
            </div>
            <span class="flex-grow-1 d-sm-none d-md-block" />
            <div class="col-md-auto col-lg-auto col-xl-auto col-sm-12 p-0 mb-3 mb-md-0">
              {actionsOnSelected({
                onScheduleModalClosed: () => actions.fetchUnvisitedPlaces(),
                section,
                state,
                translations,
              })}
            </div>
            <span class="mr-3 d-sm-none d-md-block" />
            <div class=" mr-4 col-md-auto col-lg-auto col-xl-auto col-sm-12 p-0 d-flex justify-content-end mb-3 mb-md-0">
              {columnSelector({
                translations,
                actions,
                disabled: loadingUnvisitedPlaces,
                section,
                state,
              })}
            </div>
          </div>
          <div class="position-relative styleToPrint">
            {list({ actions, section, state, translations })}
            {regionLoading({
              state: {
                on: loadingUnvisitedPlaces,
              },
            })}
          </div>

          <div class="position-relative noPrint">
            {regionLoading({
              state: {
                on: isLoading,
              },
            })}

            {currentPageNumber > 0 && (
              <table class="col-12">
                {currentPageSize === INITIAL_PAGE_SIZE && (
                  <div
                    style="height:6vh;display:flex;flex-direction:column; justify-content:center;1px solid #E5E5E5"
                    class="tableMoreResults"
                    onclick={() => {
                      actions.setPagination({
                        pageSize:
                          pageSize === INITIAL_PAGE_SIZE
                            ? BASE_PAGE_SIZE
                            : pageSize,
                        section,
                      });
                      actions.fetchUnvisitedPlaces();
                    }}
                    disabled={loadingUnvisitedPlaces}
                  >
                    <span style="color:#212529;font-size:14px;">
                      {translations["seeAllResults"]}
                    </span>
                  </div>
                )}
                <div class="d-flex justify-content-between align-items-center">
                  <caption>
                    <span class="caption" style="color:#212529;">
                      {translations["placesWithoutVisits"]}{" "}
                      <b style="color:#212529">
                        {itemCount
                          ? new Intl.NumberFormat("pt-BR").format(
                              (currentPageNumber - 1) * currentPageSize + 1,
                            )
                          : 0}
                      </b>{" "}
                      a{" "}
                      <b style="color:#212529">
                        {new Intl.NumberFormat("pt-BR").format(
                          (currentPageNumber - 1) * currentPageSize +
                            currentPageSize <
                            itemCount
                            ? (currentPageNumber - 1) * currentPageSize +
                                currentPageSize
                            : itemCount,
                        )}
                      </b>{" "}
                      {itemCount === undefined ? (
                        <span />
                      ) : (
                        <span style="color:#212529">
                          {" "}
                          de{" "}
                          <b style="color:#212529">
                            {new Intl.NumberFormat("pt-BR").format(
                              itemCount >= 1 ? itemCount : 0,
                            )}
                          </b>{" "}
                        </span>
                      )}
                    </span>
                  </caption>
                  {pagination({
                    actions: {
                      onChange: () => {
                        actions.fetchUnvisitedPlaces();
                      },
                      setPagination: actions.setPagination,
                    },
                    section,
                    state: {
                      currentPageNumber,
                      disabled: loadingUnvisitedPlaces,
                      pageCount,
                      pageNumber,
                      pageNumberInvalid,
                      pageSize,
                    },
                  })}
                </div>
              </table>
            )}
          </div>
          {emptyState({
            translations,
            state: {
              show: itemCount === 0 && currentPageSize != INITIAL_PAGE_SIZE,
            },
          })}
          {currentPageSize === INITIAL_PAGE_SIZE && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            />
          )}
        </div>
        {(window.onload = firstPageLoad)}
      </div>
    </div>
  );
};
